import React from "react";
import BasicDialog from "./BasicDialog";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const ConfirmDialog = ({
  open,
  title,
  desc,
  handleConfirm,
  handleClose,
  actionButtonLabel,
  actionButtonColor,
  loading,
}) => {
  return (
    <BasicDialog open={open} handleClose={handleClose}>
      {/* <Box>
        <Box sx={{ fontWeight: "bold", fontSize: "1.3rem", mb: "2rem" }}>
          {title}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? <CircularProgress size={25} /> : actionButtonLabel}
          </Button>
          <Button variant="contained" onClick={handleClose}>
            Cancel
          </Button>
         
        </Box>
      </Box> */}
      <Box sx={{ display: "flex", gap: 3 }}>
        <Box
          sx={{
            backgroundColor: "#dec4c4",
            color: "#e98484",
            p: 1,
            borderRadius: "50%",
            height: "fit-content",
          }}
        >
          <WarningAmberIcon />
        </Box>
        <Box>
          <Typography
            sx={{ fontSize: "1rem", fontWeight: "600", color: "black" }}
          >
            {title}
          </Typography>
          <Typography sx={{ color: "#8e8383", fontSize: "12px", marginTop: 2 }}>
            {desc}
          </Typography>
          <Box
            sx={{
              display: "flex",
              textAlign: "right",
              gap: 2,
              marginTop: 3,
              justifyContent: "right",
            }}
          >
            <Button
              sx={{ border: "1px solid black", color: "black" }}
              variant="outlined"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color={
                actionButtonColor || (actionButtonLabel.toLowerCase() === "confirm"
                  ? "success"
                  : "error")
              }
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? <CircularProgress size={25} /> : actionButtonLabel}
            </Button>
          </Box>
        </Box>
      </Box>
    </BasicDialog>
  );
};

export default ConfirmDialog;
